import AudioCubeApiCallerInstance from '../../utils/AudioCubeApiCallerInstance';
import { SOUNDBOX_API_ENDPOINTS } from '../../URLConstants';

const multipartHeaders = {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
};

export const GetAllTickets = async (page, limit, where, startDate, endDate, signal) => {
  const response = await AudioCubeApiCallerInstance.get(SOUNDBOX_API_ENDPOINTS.TICKET_MANAGEMENT, {
    params: {
      page,
      limit,
      ...(startDate && { startDate }),
      ...(endDate && { endDate }),
      ...(where && { where: JSON.stringify(where) })
    },
    ...(signal && { signal })
  });
  return response;
};

export const GetTicketById = async (ticketId) => {
  const response = await AudioCubeApiCallerInstance.get(
    `${SOUNDBOX_API_ENDPOINTS.TICKET_MANAGEMENT}/${ticketId}`
  );
  return response;
};

export const GetTicketByFreshdeskId = async (freshdeskTicketId) => {
  const response = await AudioCubeApiCallerInstance.get(
    `${SOUNDBOX_API_ENDPOINTS.TICKET_MANAGEMENT}/freshdesk-tickets/${freshdeskTicketId}`
  );
  return response;
};

export const GetTicketTimeline = async (ticketId) => {
  const response = await AudioCubeApiCallerInstance.get(
    `${SOUNDBOX_API_ENDPOINTS.TICKET_MANAGEMENT}/${ticketId}/timeline`
  );
  return response;
};

export const GetTicketStats = async (params) => {
  const response = await AudioCubeApiCallerInstance.get(
    `${SOUNDBOX_API_ENDPOINTS.TICKET_MANAGEMENT}/stats`,
    { params }
  );
  return response;
};

export const CreateTicket = async (formData) => {
  const response = await AudioCubeApiCallerInstance.post(
    SOUNDBOX_API_ENDPOINTS.TICKET_MANAGEMENT,
    formData,
    multipartHeaders
  );
  return response;
};

export const UpdateTicket = async (ticketId, formData) => {
  const response = await AudioCubeApiCallerInstance.patch(
    `${SOUNDBOX_API_ENDPOINTS.TICKET_MANAGEMENT}/${ticketId}`,
    formData,
    multipartHeaders
  );
  return response;
};
